import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * Barra entre o cabeçalho e o conteúdo (§31): busca, filtros e ações secundárias. No celular
 * cada item ocupa a linha inteira; a partir do tablet, ficam lado a lado.
 */
export function PageToolbar({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      role="search"
      className={cn(
        'flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center [&>*]:w-full sm:[&>*]:w-auto',
        className,
      )}
    >
      {children}
    </div>
  );
}
